/**
 * Кошельки с источником данных на экране «Интеграции» (docs/08-screens.md):
 * откуда данные, когда собирались последний раз и чем закончилось.
 */
import { useNavigate } from 'react-router-dom';
import { Badge, Button, Card } from '@/ds';
import { Provenance } from '@/components/money';
import type { WalletIntegrationRow } from '@/api/hooks';
import { formatRelative } from '@/lib/format';

function statusBadge(row: WalletIntegrationRow) {
  if (row.failureStreak >= 3) {
    return (
      <Badge tone="danger" dot>
        Падает подряд
      </Badge>
    );
  }
  if (row.lastSyncStatus === 'failed') {
    return (
      <Badge tone="warning" dot>
        Последний сбор с ошибкой
      </Badge>
    );
  }
  if (row.lastSyncAt) {
    return (
      <Badge tone="success" dot>
        Работает
      </Badge>
    );
  }
  return <Badge tone="neutral">{row.source === 'telegram_forward' ? 'Ждёт сообщений' : 'Не собирался'}</Badge>;
}

export function WalletSourcesCard({ wallets }: { wallets: WalletIntegrationRow[] }) {
  const navigate = useNavigate();
  if (wallets.length === 0) return null;

  return (
    <Card padding="md">
      <div
        style={{
          font: '500 16px var(--font-display)',
          letterSpacing: 'var(--ls-heading)',
          color: 'var(--text-strong)',
        }}
      >
        Кошельки с источником данных
      </div>

      <div style={{ marginTop: 'var(--space-3)', display: 'flex', flexDirection: 'column' }}>
        {wallets.map((wallet) => (
          <div
            key={wallet.id}
            style={{
              paddingTop: 'var(--space-4)',
              paddingBottom: 'var(--space-4)',
              borderTop: '1px solid var(--border-subtle)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 'var(--space-4)',
            }}
          >
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ font: '500 14px var(--font-text)', color: 'var(--text-strong)' }}>
                {wallet.name}
              </div>
              <Provenance>{wallet.sourceTitle}</Provenance>
              <Provenance>
                {wallet.lastSyncAt
                  ? `${wallet.source === 'telegram_forward' ? 'Последнее пересланное сообщение' : 'Последний сбор'} ${formatRelative(wallet.lastSyncAt)}`
                  : wallet.source === 'telegram_forward'
                    ? 'Сообщений ещё не пересылали'
                    : 'Из источника ещё не собирался'}
                {wallet.lastSyncError ? `. ${wallet.lastSyncError}` : ''}
              </Provenance>
            </div>
            {statusBadge(wallet)}
            <Button variant="ghost" size="sm" onClick={() => navigate(`/wallets/${wallet.id}`)}>
              Открыть
            </Button>
          </div>
        ))}
      </div>
    </Card>
  );
}
